<script>
    import FilterObject from '@/components/page-file-edit/FilterObject.vue';


    export default {
        props: {
            file: Object,
        },
        components: {
            FilterObject: FilterObject,
        },
        computed: {
            filters() { return this.$store.getters.FILTER_BY_ASSET_TYPE(
                this.$store.getters.ASSET_TYPE_IMAGES
            ) }
        }
    }
</script>


<template>
    <div class="image_filter">
        <FilterObject 
            v-for="(filterValue, filterIndex) in filters" :key="filterIndex"
            :filter = "filterValue"
            :file = "file"
        />
    </div>    
</template>


<style scoped>
    .image_filter {
        flex: 1 1 100%;

        margin: 5px;

        background-color: var(--background);
        border: 1px solid var(--background-separator);

        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
    }
</style>